import { ShieldCheck } from "lucide-react";
import { useEffect, useState } from "react";
import { Link } from "react-router";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Dialog } from "@/components/ui/dialog";
import { useMe, useUpdateProfile } from "@/hooks/useMe";
import { AI_CONSENT_EVENT } from "@/lib/api";
import { t } from "@shared/i18n";

/** Accord explicite avant le premier envoi au fournisseur d'IA (exigé par l'App Store, règle 5.1.2). */
export function AiConsentDialog() {
  const { data: me } = useMe();
  const update = useUpdateProfile({ silent: true });
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const on = () => setOpen(true);
    window.addEventListener(AI_CONSENT_EVENT, on);
    return () => window.removeEventListener(AI_CONSENT_EVENT, on);
  }, []);
  // Demandé une fois, dès l'arrivée dans l'application.
  useEffect(() => {
    if (me && !me.profile.aiConsentAt) {
      let asked = false;
      try {
        asked = sessionStorage.getItem("gbc.ai-consent-asked") === "1";
        sessionStorage.setItem("gbc.ai-consent-asked", "1");
      } catch {
        asked = false;
      }
      if (!asked) setOpen(true);
    }
  }, [me]);
  if (!open || !me) return null;
  return (
    <Dialog open onOpenChange={setOpen} title={t("Votre Copilote utilise une IA")} description={t("Une seule fois : votre accord avant d'utiliser les fonctions d'intelligence artificielle.")} className="max-w-md">
      <div className="space-y-4 text-[14px] leading-relaxed">
        <div className="flex gap-3 rounded-2xl bg-surface p-4">
          <ShieldCheck className="mt-0.5 size-5 shrink-0 text-primary" />
          <div className="space-y-2">
            <p>{t("Quand vous utilisez le Coach ou une fonction IA (documents, marketing, rappels, comptes rendus…),")} <b>{t("votre demande et les informations utiles de votre espace")}</b> {t("sont envoyées à notre fournisseur d'IA,")} <b>{t("DeepSeek")}</b>{t(", pour produire la réponse.")}</p>
            <p className="text-muted">{t("Ces données peuvent être traitées hors de l'Union européenne. Évitez d'y mettre des informations sensibles (santé, mots de passe, numéros de carte). Vous pouvez retirer votre accord à tout moment dans Paramètres › Confidentialité.")}</p>
          </div>
        </div>
        <p className="text-[12px] text-muted">
          {t("En savoir plus :")} <Link to="/legal/confidentialite" className="underline" onClick={() => setOpen(false)}>{t("politique de confidentialité")}</Link>.
        </p>
        <div className="flex flex-col gap-2 sm:flex-row-reverse">
          <Button className="flex-1" loading={update.isPending} onClick={() => update.mutate({ aiConsent: true }, { onSuccess: () => { setOpen(false); toast.success(t("Merci ! Votre Copilote est prêt.")); } })}>{t("J'accepte")}</Button>
          <Button variant="ghost" className="flex-1" onClick={() => setOpen(false)}>{t("Plus tard")}</Button>
        </div>
        <p className="text-[12px] text-subtle">{t("Sans accord, les fonctions d'IA restent désactivées ; le reste de l'application fonctionne normalement.")}</p>
      </div>
    </Dialog>
  );
}
